export default __webpack_public_path__ + "static/media/task_planned.a65bdca9.png";